import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[appCarousel]'
})
export class CarouselDirective {

  @HostBinding('class.active') isOpen = false;

}



// WEBPACK FOOTER //
// ./src/app/shared/carousel.directive.ts